import CustomInput from "components/CustomInput/CustomInput";
import { useFormik } from "formik";
import React from "react";
import { useState } from "react";
import Modal from "react-responsive-modal";
import WellnessService from "services/WellnessService";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import * as timelineActions from "reteamStore/actions";

export default ({ onClose, teamId }) => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isScheduledTrivia, setIsScheduledTrivia] = useState(false);
	const currentDate = new Date().toISOString().split("T")[0];
	const dispatch = useDispatch();
	const { allTimelinePost } = useTeamActionContext();

	const formik = useFormik({
		initialValues: {
			title: "",
			end_date: "",
			start_date: "",
			is_scheduled: false,
		},
		validationSchema: Yup.object().shape({
			title: Yup.string().required("Please enter title"),
			start_date: Yup.date().when("is_scheduled", (isScheduled, schema) =>
				isScheduled
					? schema
						.required("Start date is required")
						.min(
							currentDate,
							"Start Date should be equal or greater than the current date"
						)
					: schema.nullable()
			),
			end_date: Yup.date()
				.required("End date is required")
				.when("start_date", (eventStartDate, schema) =>
					eventStartDate
						? schema.min(
							eventStartDate,
							"End Date should be equal or greater than Start Date"
						)
						: schema.min(
							currentDate,
							"End Date should be equal or greater than Current Date"
						)
				),
		}),
		onSubmit: (values) => submitForm(values),
		validateOnChange: true,
	});

	const submitForm = async (data) => {
		setIsSubmitting(true);
		const date = new Date().toISOString().split("T")[0];
		const payload = {
			title: data.title,
			triviaId: 0,
			teamId,
			endDate: data.end_date,
			startDate: data.start_date || date,
		};

		WellnessService.createTrivia(payload)
			.then(() => {
				setIsSubmitting(false);
				onClose(true);
			})
			.catch(setIsSubmitting(false));


		dispatch(timelineActions.clearAll());
		allTimelinePost();

	};

	return (
		<Modal
			center
			closeOnEsc={false}
			closeOnOverlayClick={false}
			// styles={{
			//   modal: {
			//     maxWidth: "60%",
			//     width: "60%",
			//     borderRadius: "10px",
			//   },
			// }}
			classNames={{
				modal: "createTaskModal",
			}}
			open
			onClose={() => onClose(false)}
		>
			<div className="mt-3">
				<form noValidate onSubmit={formik.handleSubmit}>
					<h5 className="mt-2 mb-1">
						<strong>Tiriva Title</strong>
					</h5>
					<CustomInput
						inputClass="user-profile-inputs"
						id={"title"}
						formGroup={false}
						inputProps={{
							placeholder: "Title",
							type: "text",
							...formik.getFieldProps("title"),
							error: formik.errors.title,
						}}
					/>
					<h5 className="mt-2 mb-1">
						<strong>End Date</strong>
					</h5>
					<CustomInput
						inputClass="user-profile-inputs"
						id={"end_date"}
						formGroup={false}
						inputProps={{
							placeholder: "End Date",
							type: "date",
							...formik.getFieldProps("end_date"),
							error: formik.errors.end_date,
						}}
					/>

					<label className="mt-2">
						<input
							type="checkbox"
							style={{ transform: "scale(1.5)" }}
							checked={isScheduledTrivia}
							onChange={() => {
								formik.setFieldValue("is_scheduled", !isScheduledTrivia);
								formik.setFieldValue("start_date", "");
								formik.setErrors({ end_date: "" });
								setIsScheduledTrivia(!isScheduledTrivia);
							}}
						/>
						&nbsp;&nbsp;Schedule Trivia
					</label>

					{isScheduledTrivia && (
						<>
							<h5 className="mt-2 mb-1">
								<strong>Start Date</strong>
							</h5>
							<CustomInput
								inputClass="user-profile-inputs"
								id={"start_date"}
								formGroup={false}
								inputProps={{
									placeholder: "Start Date",
									type: "date",
									...formik.getFieldProps("start_date"),
									error: formik.errors.start_date,
								}}
							/>
						</>
					)}

					<div className="d-flex justify-content-end mt-2">
						<button
							className="btn btn-md btn-dark"
							type="submit"
							disabled={isSubmitting}
						>
							Submit
						</button>
					</div>
				</form>
				{/* <Formik
          initialValues={{}}
          onSubmit={(values, actions) => {
            console.log(values);
            submitForm(values);
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string().required("Please enter name"),
            start_date: Yup.string().required("Please enter name"),
            end_date: Yup.string().required("Please enter name"),
          })}
        >
          <Form>
            <Field name="name">
              {({ field, meta }) => (
                <div>
                  <h5>
                    <strong>Trivia Title</strong>
                  </h5>
                  <CustomInput
                    inputProps={{
                      value: field.value,
                      style: { height: "45px" },
                      name: field.name,
                      required: true,
                    }}
                    inputClass="user-profile-inputs"
                    startIcon={false}
                    onChange={field.onChange}
                  />
                  {meta.touched && meta.error && (
                    <div className="error">{meta.error}</div>
                  )}
                </div>
              )}
            </Field>
            <Field name="end_date">
              {({ field, meta }) => (
                <div>
                  <h5>
                    <strong>End Date</strong>
                  </h5>
                  <CustomInput
                    inputProps={{
                      value: field.value,
                      style: { height: "45px" },
                      name: field.name,
                      required: true,
                      type: "date",
                      min: new Date(),
                    }}
                    inputClass="user-profile-inputs"
                    startIcon={false}
                    onChange={field.onChange}
                  />
                  {meta.touched && meta.error && (
                    <div className="error">{meta.error}</div>
                  )}
                </div>
              )}
            </Field>

            <label className="mt-2">
              <input
                type="checkbox"
                style={{ transform: "scale(1.5)" }}
                checked={isScheduledTrivia}
                onChange={() => setIsScheduledTrivia(!isScheduledTrivia)}
              />
              &nbsp;&nbsp;Schedule Trivia
            </label>

            {isScheduledTrivia && (
              <Field name="start_date">
                {({ field, meta }) => (
                  <div>
                    <h5>
                      <strong>Start Date</strong>
                    </h5>
                    <CustomInput
                      inputProps={{
                        value: field.value,
                        style: { height: "45px" },
                        name: field.name,
                        required: true,
                        type: "date",
                        min: new Date(),
                      }}
                      inputClass="user-profile-inputs"
                      startIcon={false}
                      onChange={field.onChange}
                    />
                    {meta.touched && meta.error && (
                      <div className="error">{meta.error}</div>
                    )}
                  </div>
                )}
              </Field>
            )}
            <div className="d-flex justify-content-end mt-2">
              <button
                className="btn btn-md btn-dark"
                type="submit"
                disabled={isSubmitting}
              >
                Submit
              </button>
            </div>
          </Form>
        </Formik> */}
			</div>
		</Modal>
	);
};
